module.exports = __webpack_public_path__ + "img/plans.9e773b1a.svg";